import { render, staticRenderFns } from "./back-button.component.vue?vue&type=template&id=56f50934&scoped=true"
import script from "./back-button.component.vue?vue&type=script&lang=js"
export * from "./back-button.component.vue?vue&type=script&lang=js"
import style0 from "./back-button.component.vue?vue&type=style&index=0&id=56f50934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f50934",
  null
  
)

export default component.exports